// extracted by mini-css-extract-plugin
export default {"grid-alike-section":"BoxSection_grid-alike-section__lpU1m","grid-header-right":"BoxSection_grid-header-right__KPJR-"};